import {apiService, ApiResponse} from 'features/jwt/apiService';
import { PremisesApiFilter } from 'features/premises/types';
import { SortBy } from 'features/search/filters/enums';
import { SearchResponse, Tag } from 'features/search/types';
import { PremisesObject } from 'components/pages/PremisesStartPage/types';
import { PremisesServiceEndpoints } from './config';

export class PremisesService {
    /**
     * Fetch premises with filters and sorting
     */
    static async fetchPremises(
        filters: PremisesApiFilter,
        sort: SortBy
    ): Promise<ApiResponse<SearchResponse<PremisesObject[]>>> {
        return await apiService.post<SearchResponse<PremisesObject[]>>(PremisesServiceEndpoints.search, {
            filter: filters,
            sort: ['sortOrder:asc', sort],
            limit: 500,
        });
    }

    /**
     * Fetch premises tags for a specific site
     */
    static async fetchPremisesTags(siteId: string): Promise<ApiResponse<Tag[]>> {
        return await apiService.post<Tag[]>(PremisesServiceEndpoints.tags, { siteId });
    }
}
